import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Header } from 'semantic-ui-react';
import { AppState } from 'services/types';

// Selectors
// @ts-ignore
import { makeSelectSharedEventValue } from '../../../../services/sharedEvent/selectors';

interface ConnectedProps {
    instructions: {
        name: string;
        value?: string;
    }[];
}

type Props = ConnectedProps;

export class SharedEventInstructions extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { instructions } = this.props;
        if (!instructions || !instructions.length) return null;
        return (
            <React.Fragment>
                <Header>Instructions</Header>
                {instructions.map((instruction) => (
                    <React.Fragment key={instruction.value}>
                        <Header sub className="shared-event-sub-header">
                            {instruction.name}
                        </Header>
                        {instruction.value}
                    </React.Fragment>
                ))}
            </React.Fragment>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    instructions: makeSelectSharedEventValue('instructions')
});

export default connect(mapStateToProps)(SharedEventInstructions);
